import { render, staticRenderFns } from "./ListItemNote.vue?vue&type=template&id=1a3bc166&scoped=true&"
import script from "./ListItemNote.vue?vue&type=script&lang=js&"
export * from "./ListItemNote.vue?vue&type=script&lang=js&"
import style0 from "./ListItemNote.vue?vue&type=style&index=0&id=1a3bc166&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a3bc166",
  null
  
)

export default component.exports